export const constructParams = (selectedOption, startDate, endDate) => {
  let params = "";
  params += `&startDate=${startDate}`;
  params += `&endDate=${endDate}`;
  if (selectedOption === "") {
    params += `&filter=custom`;
  } else {
    params += `&filter=${selectedOption}`;
  }
  return params;
};
